// Countdown Timer
(function () {
  function getTarget() {
    var now = new Date();
    var lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    lastDay.setHours(23, 59, 59, 0);
    return lastDay;
  }

  var target = getTarget();

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    var now = Date.now();
    var diff = Math.max(0, target.getTime() - now);
    var days  = Math.floor(diff / 86400000);
    var hours = Math.floor((diff % 86400000) / 3600000);
    var mins  = Math.floor((diff % 3600000)  / 60000);
    var secs  = Math.floor((diff % 60000)    / 1000);

    var d = document.getElementById('cd-days');
    var h = document.getElementById('cd-hours');
    var m = document.getElementById('cd-mins');
    var s = document.getElementById('cd-secs');

    if (d) d.textContent = pad(days);
    if (h) h.textContent = pad(hours);
    if (m) m.textContent = pad(mins);
    if (s) s.textContent = pad(secs);
  }

  tick();
  setInterval(tick, 1000);
})();

// Code reveal on "Join to Unlock Code" click
(function () {
  var btn = document.getElementById('btn-unlock');
  var box = document.getElementById('code-box');
  if (btn && box) {
    btn.addEventListener('click', function () {
      box.classList.toggle('revealed');
    });
  }
})();